import { IFaqArticleSearchTag } from '../../../faq.types'
import eventBus from '../../../../../../services/eventBus'

const created = (tag: IFaqArticleSearchTag) => {
  eventBus.pub('faq.articleSearchTags.created', tag)
}

const updated = (tag: Partial<IFaqArticleSearchTag>, id: IFaqArticleSearchTag['id']) => {
  eventBus.pub('faq.articleSearchTags.updated', { updates: tag, id })
}

const remove = (id: IFaqArticleSearchTag['id']) => {
  eventBus.pub('faq.articleSearchTags.deleted', id)
}

const articleSearchTagsEvents = { created, updated, remove }
export default articleSearchTagsEvents
